import OfflineStatus from './OfflineStatus.container'

export default OfflineStatus
